module.exports = __webpack_public_path__ + "img/promo_mobile.2c5d7af.jpg";